import type { FormContextProps } from '../elements/formContext';
import { getGlobalize } from '../../translate';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { Component } from '../elements/Component';
import { FormContextConsumer } from '../elements/formContext';
import { NullableTextInput } from './NullableText';

interface ICurrencyInputProps {
    automation?: string;
    disabled?: boolean;
    error?: string;
    onChange: (value: number | null) => void;
    onDoValidate?: () => void;
    placeholder?: string;
    value: number | null;
}

interface ICurrencyInputState {
    value: string | null;
}

const parser = (value: string): number => getGlobalize().numberParser()(value);

export class CurrencyInput extends Component<FormContextProps<ICurrencyInputProps>, ICurrencyInputState> {
    constructor(props: ICurrencyInputProps) {
        super(props);

        this.state = {
            value: props.value === null ? null : currencyFormatter(props.value / 100),
        };
    }

    public async componentDidUpdate(prevProps: Readonly<FormContextProps<ICurrencyInputProps>>) {
        if (this.props.value !== prevProps.value) {
            await this.setState({
                value:
                    this.props.value === undefined || this.props.value === null
                        ? null
                        : currencyFormatter(this.props.value / 100),
            });
        }
    }

    public render() {
        return (
            <FormContextConsumer {...this.props}>
                {(properties) => {
                    return (
                        <NullableTextInput
                            className={this.props.automation ? `automation-${this.props.automation}` : ''}
                            disabled={properties.disabled}
                            error={properties.error}
                            onChange={async (newValue) => {
                                await this.setState({ value: newValue });
                            }}
                            onDoValidate={async () => {
                                if (this.state.value !== null) {
                                    const parsed = parser(this.state.value);
                                    if (isNaN(parsed)) {
                                        await this.setState({ value: null });
                                    } else {
                                        await this.setState({ value: currencyFormatter(parsed) });
                                        await properties.onChange(Math.round(parsed * 100));

                                        if (properties.onDoValidate) {
                                            properties.onDoValidate();
                                        }
                                    }
                                } else {
                                    await properties.onChange(null);

                                    if (properties.onDoValidate) {
                                        properties.onDoValidate();
                                    }
                                }
                            }}
                            placeholder={properties.placeholder}
                            value={this.state.value}
                        />
                    );
                }}
            </FormContextConsumer>
        );
    }
}
